export default __webpack_public_path__ + "static/media/PoweredBy_Dark.23b21500.svg";